import { LayoutActionType } from './layout.actionCreators';
import { GO_TOP, LOCK_BODY, UNLOCK_BODY } from './layout.actionTypes';

import { LayoutTriggers } from 'defs/layout';
import { LayoutTriggerValueType } from 'defs/layout';
import routes from 'defs/routes';

import { ActionType as ViewActionType, actionTypes as viewAT } from 'store/view';

export type LayoutStateType = {
	triggerComponent?: LayoutTriggerValueType;
	bodyLocked: boolean | null;
	goTop: string | null;
	opts?: Object;
};

export type RootStateType = {
	layout: LayoutStateType;
};

export const initialState: LayoutStateType = {
	triggerComponent: undefined,
	bodyLocked: null,
	goTop: null,
};

const doNotResetLockStateOnViewChange: Array<string> = [routes.dashboard.newMeasurement.id, routes.favorites.detail.id];

export default (state: LayoutStateType = initialState, action: LayoutActionType | ViewActionType) => {
	switch (action.type) {
		case viewAT.CHANGE_VIEW_ID:
			/*
			 * Force view unlock
			 * @see https://jira.migros.net/browse/PULSWM-2985 No. 7
			 */
			if (!!~doNotResetLockStateOnViewChange.indexOf(action.viewID)) {
				return state;
			}

			return {
				...state,
				triggerComponent: LayoutTriggers.Router,
				bodyLocked: false,
			};
		case LOCK_BODY:
			if (state.bodyLocked === true) {
				return state;
			}

			const tempState = {
				...state,
				triggerComponent: action.triggerComponent,
				bodyLocked: true,
			};

			if (action.opts) {
				tempState.opts = action.opts;
			}

			return tempState;

		case UNLOCK_BODY:
			if (state.bodyLocked === false) {
				return state;
			}

			return {
				...state,
				triggerComponent: action.triggerComponent,
				bodyLocked: false,
				goTop: null, // reset go top if new unlock
			};
		case GO_TOP:
			if (state.goTop === action.id) {
				return state;
			}

			return {
				...state,
				triggerComponent: action.triggerComponent,
				goTop: action.id,
			};
		default:
			return state;
	}
};
